<template>
  <el-container class="ProductionForm">
    <el-main class="p-0 pb-default">
      <el-form
        ref="form"
        class="form-label-80"
        label-width="80px"
        :model="data"
        :rules="rules"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="품목" prop="product_id">
              <AProductSelector
                v-bind:class="{ readonly: disableEdit }"
                :disabled="disableEdit"
                :value="data.product_name"
                @select="handleSelectProduct"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="규격" prop="size">
              <el-input
                v-model="data.size"
                v-bind:class="{ readonly: disableEdit }"
                :disabled="disableEdit"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="생산번호" prop="code">
              <el-input v-model="data.code" class="readonly" readonly />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="사양" prop="specification">
              <el-input v-model="data.specification" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="계획수량" prop="plan_amount">
              <ANumberInput
                v-model="data.plan_amount"
                v-bind:class="{ readonly: disableEdit }"
                :disabled="disableEdit"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="단위" prop="unit_id">
              <AProductUnitSelector
                v-model="data.unit_id"
                :id="data.product_id"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="거래처명" prop="customer_name">
              <ACustomerSelector
                v-bind:class="{ readonly: disableEdit }"
                :disabled="disableEdit"
                :value="data.customer_name"
                seller
                @select="handleSelectCustomer"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="계획일" prop="plan_date">
              <ADatePicker v-model="data.plan_date" :clearable="false" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="납기일" prop="delivery_date">
              <ADatePicker
                v-model="data.delivery_date"
                v-bind:class="{ readonly: disableEdit }"
                :disabled="disableEdit"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="비고" prop="desc">
              <el-input v-model="data.desc" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row
          v-if="
            data.options &&
              data.options.specifications &&
              (data.options.specifications.length > 0 ||
                data.options.descriptions.length)
          "
        >
          <el-col :span="24">
            <el-form-item label="옵션" prop="desc">
              <el-tag
                v-for="item in data.options.specifications"
                type="danger"
                class="mr-default"
                :key="item.name"
                effect="dark"
              >
                {{ item.name }}
              </el-tag>
              <el-tag
                v-for="item in data.options.descriptions"
                type="primary"
                class="mr-default"
                :key="item.name"
                effect="dark"
              >
                {{ item.name }}
              </el-tag>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-tabs ref="tabs" v-model="active_tab" type="card">
        <el-tab-pane label="생산지시" name="1">
          <div
            class="bomtree-container flex of-auto"
            style="max-height: 400px;"
          >
            <div class="flex-fixed" style="width: 500px;">
              <ABomTree
                ref="tree"
                v-if="isSelectedProduct"
                :id="data.product_id"
                :size="data.size"
                :specifications="data.specifications"
                :options="data.options"
                :data="data.detail"
                :editable="true"
                selectionMode
                @completed="handleBomTreeCompleted"
              />
            </div>
            <div class="flex-auto of-auto">
              <ABomTable :production="production" :material="material" />
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="품번조회" name="2" v-if="!isNew">
          <SerialView :id="target ? target.contract_detail_id : undefined" />
        </el-tab-pane>
      </el-tabs>
    </el-main>
    <el-footer v-if="!hideFooter">
      <el-button
        type="primary"
        v-shortkey="['F4']"
        :disabled="
          data.status_flag !== '0' || !has_grant_write || data.plan_amount < 0
        "
        :loading="load_button"
        @shortkey.native="handleClickRegister"
        @click="handleClickRegister"
        >{{ $t("button.register") }}(F4)</el-button
      >
      <el-button
        v-if="!isNew"
        type="danger"
        :disabled="data.status_flag !== '0' || !has_grant_write"
        @click="handleClickDelete"
        >삭 제</el-button
      >
      <el-button class="close-button" @click="handleCloseDialog"
        >{{ $t("button.close") }}(Esc)</el-button
      >
    </el-footer>
  </el-container>
</template>
<script>
import { mapGetters } from "vuex";
import { form } from "@/common/mixins/form";
import { production_process } from "@/common/mixins/production_process";
import SerialView from "@/spa/Common/SerialView";

export default {
  name: "ProductionForm",
  mixins: [form, production_process],
  components: { SerialView },
  data() {
    return {
      title: "생산 지시",
      data: {},
      production_item: {},
      // 객체가 깊어지는 경우 변경이 감지되지 않아서 변수로 선언하여 사용
      bom: [],
      production: [],
      material: [],
      rules: {
        product_id: [{ required: true, message: "품목을 선택해 주세요." }],
        // unit_id: [{ required: true, message: "단위를 선택해 주세요.", trigger: ["blur", "change"] }],
        plan_date: [{ required: true, message: "계획일을 선택해 주세요." }],
        plan_amount: [{ required: true, message: "계획수량을 입력해 주세요." }],
      },
      active_tab: "1",
      load_button: false,
    };
  },
  props: {
    // 생산 데이터
    target: {
      type: Object,
      default: function() {
        return {
          id: 0,
          code: "",
          plan_date: this.util.getDate(),
          delivery_date: this.util.getDate(1),
          product_id: undefined,
          product_name: "",
          status_flag: "0",
          detail: {
            bom: [],
            production: [],
            material: [],
          },
          unit_id: 1,
          isProduction: false,
          size: "",
        };
      },
    },
    // 수주 상세 데이터
    source: {
      type: Object,
    },
    hideFooter: {
      type: Boolean,
      default: false,
    },
    has_grant_write: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    if (this.source) {
      this.loadSource();
    } else {
      this.data = Object.assign({}, this.target);
      this.isProduction = true;
    }
  },
  computed: {
    ...mapGetters(["table_product"]),
    isNew: function() {
      return this.data.id < 1;
    },
    isSelectedProduct() {
      // if (this.isProduction) { return false }
      let ret = this.data.product_id;
      return ret;
    },
    disableEdit() {
      return !!this.source || this.data.contract_detail_id > 0;
    },
  },
  methods: {
    // Contract Detail 정보로 생산 지시 정보를 생성
    loadSource() {
      let param = { id: this.source.contract_id };
      this.api.listProductionContract(param).then((res) => {
        let data;
        if (res.data.length > 0) {
          data = res.data.forEach(
            (d) => d.contract_detail_id === this.source.id
          );
          if (data) {
            this.data = Object.assign({}, data);
            this.data.detail = {
              bom: [],
              production: [],
              material: [],
            };
          }
        }
        if (!data) {
          this.data = {
            id: 0,
            code: "",
            contract_id: this.source.contract_id,
            contract_detail_id: this.source.id,
            plan_date: this.util.getDate(),
            delivery_date: this.util.getDate(1),
            customer_id: this.source.customer_id,
            customer_name: this.source.customer_name,
            plan_amount: this.source.amount,
            product_id: this.source.product_id,
            product_name: this.source.product_name,
            size: this.source.size,
            specification: this.source.specification,
            specifications: this.source.specifications,
            unit_id: this.source.unit_id,
            status_flag: "0",
            options: this.source.options,
            desc: this.source.desc,
            detail: {
              bom: [],
              production: [],
              material: [],
              size: {},
            },
          };
        }
      });
    },
    doRegister() {
      let params = [this.data];
      if (this.processing) {
        return;
      }
      this.load_button = true;
      this.processProduction(
        "생산 등록 중입니다.",
        () => this.api.registerProduction(params),
        {
          success: (res) => this.handleResponse(res, "등록되었습니다."),
          always: () => (this.load_button = false),
        }
      );
    },
    doDelete() {
      let params = [this.data.id];
      this.processProduction(
        "생산 취소 중입니다.",
        () => this.api.deleteProduction(params),
        { success: (res) => this.handleResponse(res, "삭제되었습니다.") }
      );
    },
    handleBomTreeCompleted(result) {
      // 생산 대기중이 아니리면 업데이트 하지 않는다.
      if (this.data.status_flag !== "0") {
        return;
      }
      this.data.detail = result;
      this.bom = Object.assign([], result.bom);
      this.production = Object.assign([], result.production);
      this.material = Object.assign([], result.material);
      this.$emit("loaded");
    },
    // handleClickRegister() {
    //   let isValid = true;
    //   this.items.forEach(item => {
    //     if (!isValid) { return false; }
    //             if (!item.plan_date) {
    //       this.util.notify_warning(this, this.title,
    //       item.product_name + " 계획일을 선택해 주세요.");
    //       isValid = false;
    //     }
    //     if (!isValid) { return false; }
    //     if (item.detail.bom.length < 1) {
    //       this.util.notify_warning(this, this.title,
    //       item.product_name + " 생산 계획을 선택해 주세요.");
    //       isValid = false;
    //     }
    //   })
    //   if (!isValid) { return; }
    //   this.api.registerProduction(this.items).then(res => {
    //     if (res.error !== this.system.noError) {
    //       this.util.notify_response_error(this, this.title, res);
    //       return;
    //     }
    //     this.util.notify_success(this, this.title, "등록되었습니다.");
    //   this.$emit('completed', true);
    //   });
    // },
    handleSelectProduct(product) {
      if (!product || typeof product === "string") {
        this.data.product_id = undefined;
        this.production = [];
        this.material = [];
      } else {
        this.data.product_id = product.id;
        this.data.product_name = product.name;
        this.data.size = product.size;
      }
    },
    handleSelectCustomer(customer) {
      if (!customer || typeof customer === "string") {
        this.data.customer_id = undefined;
      } else {
        this.data.customer_id = customer.id;
        this.data.customer_name = customer.name;
      }
    },
    handleClickRegister() {
      if (!this.has_grant_write) {
        return;
      }
      if (this.hideFooter) {
        return;
      }
      if (this.data.status_flag !== "0") {
        return;
      }
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        if (this.data.detail.bom.length < 1) {
          this.util.notify_warning(
            this,
            this.title,
            "BOM이 등록된 품목을 선택해 주세요."
          );
          return;
        }
        this.doRegister();
      });
    },
    handleClickDelete() {
      this.util.confirm_delete(this, this.title, this.doDelete);
    },
    handleCloseDialog() {
      this.$emit("completed");
    },
    handleResponse(res, message) {
      if (res.error !== this.system.noError) {
        this.util.notify_response_error(this, this.title, res);
        return;
      }
      if (!this.hideFooter) {
        this.util.notify_success(this, this.title, message);
      }
      this.$emit("completed", true);
    },
  },
};
</script>

<style lang="scss">
.ProductionForm {
  .bomtree-container {
    max-height: 400px;
    overflow: auto;
  }
}
</style>
